import { Component } from "react";
import PropTypes from "prop-types";
import DateTimePicker from "components/calendar/date-time-picker";

class TodoDateSelectionCalendar extends Component {
  static propTypes = {
    selectedDate: PropTypes.number,
    newDateSelected: PropTypes.func,
    className: PropTypes.string,
    bottomComponent: PropTypes.element,
    clockEnabled: PropTypes.bool,
  };

  static defaultProps = {
    selectedDate: 0,
    newDateSelected: () => {},
    className: "",
    bottomComponent: undefined,
    clockEnabled: false,
  };

  render() {
    return (
      <DateTimePicker
        selectedDate={this.props.selectedDate}
        extraClass={this.props.className}
        bottomComponent={this.props.bottomComponent}
        handleDayClick={this.props.newDateSelected}
        clockEnabled={this.props.clockEnabled}
      />
    );
  }
}

export default TodoDateSelectionCalendar;
